<template>
  <th
    :class="['pointer', { 'is-sorted': sort === sorted }]"
    @click="click(sort)"
  >
    <slot></slot>
    <i v-if="sort === sorted && sortDir === '-'">&#9660;</i>
    <i v-if="sort === sorted && sortDir === ''">&#9650;</i>
  </th>
</template>

<script>
export default {
  name: "col-sort",

  props: ["click", "sort", "sorted", "sortDir"]
};
</script>

<style lang="scss" scoped>
th {
  white-space: nowrap;
}
.is-sorted {
  background: #e6ecf3;
}
</style>
